import { UserFollowReduxType } from '@userlist/types/UserListTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: UserFollowReduxType = {
  userName: '',
  initialTab: 0,
};

const userDetailSlice = createSlice({
  name: 'userDetail',
  initialState,
  reducers: {
    setUserName: (state, action: PayloadAction<string>) => {
      state.userName = action.payload;
    },
    setInitialTab: (state, action: PayloadAction<number>) => {
      state.initialTab = action.payload;
    },
    clearUserDetail: (state) => {
      state.userName = '';
      state.initialTab = 0;
    },
  },
});

export const { setUserName, setInitialTab, clearUserDetail } =
  userDetailSlice.actions;

export default userDetailSlice.reducer;
